import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

export const bluewingsConfig: MiniGamePageConfig = {
  game: {
    colors: ['#014da2', '#ffffff', '#ed1c24', '#3a87fe'],
    background: {
      color: '#5f6f79',
    },
  },
  titleImage: {
    width: 203,
    height: 62,
    alt: '수원 삼성 블루윙즈 미니게임 타이틀',
    marginTop: 72,
  },
  eventPeriod: {
    endDate: '2026-12-31T23:59:59+09:00',
  },
};
